/*************************************************/
/* MAP-2024                                      */
/*************************************************/

import customEventsNames from './../customEventsNames';

export function map2024() {
    const mapSelector = '.map-2024';
    const backButtonVisibilityClass = 'map-2024--show-back-button';
    const buttonActiveClass = 'map-2024--button-active';
    const visibilityClass = 'map-2024--visible';
    const worldMapSelector = '.map-2024__world';
    const europeMapSelector = '.map-2024__europe';
    const assetMarketMapSelector = '.map-2024__asset-market';
    const usaMapSelector = '.map-2024__usa';
    const usaZoomButtonSelector = '#USA';
    const europeZoomButtonSelector = '#Europa';
    const backButtonSelector = '.map-2024__back-button';
    const powerAndGasButtonSelector = '.map-2024__power-and-gas-button';
    const assetMarketButtonSelector = '.map-2024__assets-market-button';

    const map = document.querySelector(mapSelector);
    const worldMap = map?.querySelector(worldMapSelector);
    const europeMap = map?.querySelector(europeMapSelector);
    const assetMarketMap = europeMap; //We have support for two different maps, but for now the functionality can be kept in the europe map. I keep this here for legibility
    const usaMap = map?.querySelector(usaMapSelector);
    const usaZoomButton = map?.querySelector(usaZoomButtonSelector)
    const europeZoomButton = map?.querySelector(europeZoomButtonSelector);
    const assetMarketButton = map?.querySelector(assetMarketButtonSelector);
    const powerAndGasButton = map?.querySelector(powerAndGasButtonSelector);
    const backButton = map?.querySelector(backButtonSelector);


    const setBackButtonVisiblity = (visible) => {
        if (visible) {
            map.classList.add(backButtonVisibilityClass);
        } else {
            map.classList.remove(backButtonVisibilityClass);
        }
    }

    const activatePowerAndGasButton = () => {
        assetMarketButton.classList.remove(buttonActiveClass);
        powerAndGasButton.classList.add(buttonActiveClass);
    }

    const activateAssetMarketButton = () => {
        assetMarketButton.classList.add(buttonActiveClass);
        powerAndGasButton.classList.remove(buttonActiveClass);
    }

    const hideAllMaps = () => {
        const maps = [
            worldMap,
            europeMap,
            assetMarketMap,
            usaMap,
        ];

        maps.forEach(map => {
            if (map) {
                map.classList.remove(visibilityClass);
            }
        })
    }

    const init = () => {

        //Show the USA map
        const usaButtons = [usaZoomButton];
        if (usaButtons && usaMap) {
            usaButtons.forEach(button => {
                if (button) {
                    button.addEventListener('click', e => {
                        hideAllMaps();
                        setBackButtonVisiblity(true);
                        usaMap.classList.add(visibilityClass);
                        activatePowerAndGasButton();
                    });
                }
            });
        }

        //Show the Europe map
        const europeButtons = [europeZoomButton];
        if (europeButtons && europeMap) {
            europeButtons.forEach(button => {
                if (button) {
                    button.addEventListener('click', e => {
                        hideAllMaps();
                        setBackButtonVisiblity(true);

                        const assetMarketHiddenEvent = new Event(customEventsNames.assetMarketMapHidden);
                        assetMarketMap.dispatchEvent(assetMarketHiddenEvent);

                        europeMap.classList.add(visibilityClass);
                        activatePowerAndGasButton();
                    });
                }
            });
        }

        //Show Asset Market map
        const assetMarketButtons = [assetMarketButton];
        if (assetMarketButtons && assetMarketMap) {
            assetMarketButtons.forEach(button => {
                if (button) {
                    button.addEventListener('click', e => {
                        hideAllMaps();
                        setBackButtonVisiblity(false);
                        assetMarketMap.classList.add(visibilityClass);

                        const assetMarketVisibleEvent = new Event(customEventsNames.assetMarketMapVisible);
                        assetMarketMap.dispatchEvent(assetMarketVisibleEvent);

                        activateAssetMarketButton();
                    });
                }
            });
        }

        //Show the world map
        const worldButtons = [
            backButton,
            powerAndGasButton
        ];
        if (worldButtons && worldMap) {
            worldButtons.forEach(button => {
                if (button) {
                    button.addEventListener('click', e => {
                        hideAllMaps();
                        setBackButtonVisiblity(false);
                        worldMap.classList.add(visibilityClass);
                        activatePowerAndGasButton();
                    });
                }
            });
        }
    };

    init();

}

